import React from "react";
import { LABELS } from "../labels";
import type { ValidationResult } from "../types";

interface Props {
	results: ValidationResult[];
}

const SEVERITY_COLOR: Record<"error" | "warn", string> = {
	error: "#dc2626",
	warn: "#b45309",
};

const SEVERITY_BG: Record<"error" | "warn", string> = {
	error: "#fee2e2",
	warn: "#fef9c3",
};

const SEVERITY_ICON: Record<"error" | "warn", string> = {
	error: "fa fa-times-circle",
	warn: "fa fa-exclamation-triangle",
};

export default function DrawerValidationPanel({ results }: Props) {
	if (results.length === 0) {
		return (
			<p style={{ color: "#22c55e", fontSize: "0.875rem", display: "flex", alignItems: "center", gap: 6 }}>
				<i className="fa fa-check-circle" />
				{LABELS.validationNoIssues}
			</p>
		);
	}

	const errors = results.filter((r) => r.severity === "error");
	const warns = results.filter((r) => r.severity === "warn");

	function renderGroup(items: ValidationResult[], severity: "error" | "warn", groupLabel: string) {
		if (items.length === 0) return null;
		return (
			<div style={{ marginBottom: 12 }}>
				<p
					style={{
						margin: "0 0 6px",
						fontSize: "0.75rem",
						fontWeight: 600,
						color: SEVERITY_COLOR[severity],
						textTransform: "uppercase",
					}}>
					{groupLabel}
				</p>
				{items.map((r, i) => (
					<div
						key={i}
						style={{
							display: "flex",
							gap: 8,
							alignItems: "flex-start",
							padding: "6px 10px",
							borderRadius: 6,
							background: SEVERITY_BG[severity],
							marginBottom: 4,
							fontSize: "0.8125rem",
						}}>
						<i
							className={SEVERITY_ICON[severity]}
							style={{ color: SEVERITY_COLOR[severity], marginTop: 2, flexShrink: 0 }}
						/>
						<span style={{ color: "#1e293b" }}>{r.message}</span>
					</div>
				))}
			</div>
		);
	}

	return (
		<div>
			{renderGroup(errors, "error", LABELS.validationErrors)}
			{renderGroup(warns, "warn", LABELS.validationWarnings)}
		</div>
	);
}
